import { render, staticRenderFns } from "./bottomShopList.vue?vue&type=template&id=57972ecc&scoped=true"
import script from "./bottomShopList.vue?vue&type=script&lang=js"
export * from "./bottomShopList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57972ecc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57972ecc')) {
      api.createRecord('57972ecc', component.options)
    } else {
      api.reload('57972ecc', component.options)
    }
    module.hot.accept("./bottomShopList.vue?vue&type=template&id=57972ecc&scoped=true", function () {
      api.rerender('57972ecc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/appNewRenovation/components/bottomShopList.vue"
export default component.exports